import { Link } from "react-router-dom";
import { Badges, Image, P } from "../../AbstractElements";
import { dynamicImage } from "../../service";
import { TableColumn } from "react-data-table-component";
import { MoreVertical } from "react-feather";
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown,} from "reactstrap";
import { useTranslation } from "react-i18next";
import { TFunction } from "i18next";
import { UserListTableDataColumnType } from "../../types/users/UserTypes";

type UserListTableNameProps = {
  image?: string;
  name?: string;
};

export const UserListTableData = [
  {
    "id": 1,
    "name": "Alice Johnson",
    "firstName": "Alice",
    "lastName": "Johnson",
    "birthDate": "1998-04-12",
    "gender": "Female",
    "language": "English",
    "languages": ["English"],
    "image": "dashboard-8/user1.png",
    "logo": "dashboard-8/linnk_logo.png",
    "email": "alice.johnson@example.com",
    "phonenumber": "+1-303-555-0198",
    "organizationname": "Linnk Group",
    "status": "Active",
    "role": "admin",
    "countryCode": "+1",
    "country":"United States",
    "mobileNumber": "303-555-0198",
    "date": "2024-06-01 13:45:00",
    "reason":"wrong password",
    "ActivityHistory": [
      {
        date: "2024-06-01 13:45:00",
        action: "Deleted",
        details: "User was deleted from the organization."
      },
      {
        date: "2024-05-28 09:30:00",
        action: "Edited",
        details: "User profile information was updated."
      },
      {
        date: "2024-05-20 15:10:00",
        action: "Password Changed",
        details: "User changed their password."
      },
      {
        date: "2024-06-01 13:45:00",
        action: "Deleted",
        details: "User was deleted from the organization."
      },
      {
        date: "2024-05-28 09:30:00",
        action: "Edited",
        details: "User profile information was updated."
      },
      {
        date: "2024-05-20 15:10:00",
        action: "Password Changed",
        details: "User changed their password."
      },
      {
        date: "2024-06-01 13:45:00",
        action: "Deleted",
        details: "User was deleted from the organization."
      },
      {
        date: "2024-05-28 09:30:00",
        action: "Edited",
        details: "User profile information was updated."
      },
      {
        date: "2024-05-20 15:10:00",
        action: "Password Changed",
        details: "User changed their password."
      },
      
    ],
    "acessRights":   {"Manage Location": [
      {
        "key": "AddLocation",
        "label": "Add Location",
        "value": true
      },
      {
        "key": "EditLocation",
        "label": "Edit Location",
        "value": true
      },
      {
        "key": "ViewLocation",
        "label": "View Location",
        "value": true
      },
      {
        "key": "DeleteLocation",
        "label": "Delete Location",
        "value": false
      }
    ],
    "Manage Organization": [
    {
      "key": "AddOrganization",
      "label": "Add Organization",
      "value": true
    },
    {
      "key": "EditOrganization",
      "label": "Edit Organization",
      "value": true
    },
    {
      "key": "ViewOrganization",
      "label": "View Organization",
      "value": true
    },
    {
      "key": "DeleteOrganization",
      "label": "Delete Organization",
      "value": true
    }
  ],
  "Manage Users": [
 
    {
      "key": "ViewUser",
      "label": "View User",
      "value": true
    },
    {
        "key": "EditUser",
        "label": "Edit User",
        "value": true
      },
    {
      "key": "ImpersonateUser",
      "label": "Impersonate User for Support",
      "value": true
    },
    {
      "key": "BanUser",
      "label": "Ban User",
      "value": true
    },
   
    
    {
      "key": "ResetPassword",
      "label": "Reset User Password",
      "value": true
    },
    {
      "key": "ViewAccessRights",
      "label": "View Access Rights of User",
      "value": true
    }
  ]}
  },
  {
    "id": 2,
    "name": "David Kim",
    "firstName": "David",
    "lastName": "Kim",
    "birthDate": "1999-09-22",
    "gender": "Male",
    "logo": "dashboard-8/eduspark.png",
    "language": "English",
    "languages": ["English"],
    "image": "dashboard-8/user.png",
    "email": "david.kim@example.com",
    "phonenumber": "+1-646-555-0112",
    "organizationname": "InnoWare Solutions",
    "status": "Inactive",
    "role": "employee",
    "countryCode": "+1",
    "mobileNumber": "646-555-0112",
    "country": "United States",
    "date": "2024-05-25 11:00:00",
    "reason": "account locked",
    "ActivityHistory": [
      {
        date: "2024-06-01 13:45:00",
        action: "Added",
        details: "User was added to the organization."
      },
      {
        date: "2024-05-25 11:00:00",
        action: "Edited",
        details: "User email address was updated."
      }
    ],
    "acessRights":   {"Manage Location": [
      {
        "key": "AddLocation",
        "label": "Add Location",
        "value": true
      },
      {
        "key": "EditLocation",
        "label": "Edit Location",
        "value": true
      },
      {
        "key": "ViewLocation",
        "label": "View Location",
        "value": true
      },
      {
        "key": "DeleteLocation",
        "label": "Delete Location",
        "value": false
      }
    ],
    "Manage Organization": [
    {
      "key": "AddOrganization",
      "label": "Add Organization",
      "value": true
    },
    {
      "key": "EditOrganization",
      "label": "Edit Organization",
      "value": true
    },
    {
      "key": "ViewOrganization",
      "label": "View Organization",
      "value": true
    },
    {
      "key": "DeleteOrganization",
      "label": "Delete Organization",
      "value": true
    }
  ],
  "Manage Users": [
 
    {
      "key": "ViewUser",
      "label": "View User",
      "value": true
    },
    {
        "key": "EditUser",
        "label": "Edit User",
        "value": true
      },
    {
      "key": "ImpersonateUser",
      "label": "Impersonate User for Support",
      "value": true
    },
    {
      "key": "BanUser",
      "label": "Ban User",
      "value": true
    },
   
    
    {
      "key": "ResetPassword",
      "label": "Reset User Password",
      "value": true
    },
    {
      "key": "ViewAccessRights",
      "label": "View Access Rights of User",
      "value": true
    }
  ]}
  },
  {
    "id": 3,
    "name": "Maria López",
    "firstName": "Maria",
    "lastName": "López",
    "birthDate": "1996-01-30",
    "logo": "dashboard-8/eduspark.png",
    "gender": "Female",
    "language": "Spanish",
    "languages": ["Spanish"],
    "image": "dashboard-8/user2.png",
    "email": "maria.lopez@example.com",
    "phonenumber": "+1-415-555-0174",
    "organizationname": "GlobalEdge Corp.",
    "status": "Active",
    "role": "manager",
    "countryCode": "+1",
    "mobileNumber": "415-555-0174",
    "country": "United States",
    "date": "2024-05-20 10:00:00",
    "reason": "user not found",
    "acessRights":   {"Manage Location": [
      {
        "key": "AddLocation",
        "label": "Add Location",
        "value": true
      },
      {
        "key": "EditLocation",
        "label": "Edit Location",
        "value": true
      },
      {
        "key": "ViewLocation",
        "label": "View Location",
        "value": true
      },
      {
        "key": "DeleteLocation",
        "label": "Delete Location",
        "value": false
      }
    ],
    "Manage Organization": [
    {
      "key": "AddOrganization",
      "label": "Add Organization",
      "value": true
    },
    {
      "key": "EditOrganization",
      "label": "Edit Organization",
      "value": true
    },
    {
      "key": "ViewOrganization",
      "label": "View Organization",
      "value": true
    },
    {
      "key": "DeleteOrganization",
      "label": "Delete Organization",
      "value": true
    }
  ],
  "Manage Users": [
 
    {
      "key": "ViewUser",
      "label": "View User",
      "value": true
    },
    {
        "key": "EditUser",
        "label": "Edit User",
        "value": true
      },
    {
      "key": "ImpersonateUser",
      "label": "Impersonate User for Support",
      "value": true
    },
    {
      "key": "BanUser",
      "label": "Ban User",
      "value": true
    },
   
    
    {
      "key": "ResetPassword",
      "label": "Reset User Password",
      "value": true
    },
    {
      "key": "ViewAccessRights",
      "label": "View Access Rights of User",
      "value": true
    }
  ]}
  },
  {
    "id": 4,
    "name": "John Smith",
    "firstName": "John",
    "lastName": "Smith",
    "logo": "dashboard-8/eduspark.png",
    "birthDate": "1999-04-30",
    "gender": "Male",
    "language": "English",
    "languages": ["English"],
    "image": "dashboard-8/user3.png",
    "email": "john.smith@example.com",
    "phonenumber": "+1-415-555-0145",
    "organizationname": "Innovation LMT.",
    "status": "Active",
    "role": "employee",
    "countryCode": "+1",
    "mobileNumber": "415-555-0145",
    "country": "United States",
    "date": "2024-05-18 09:00:00",
    "reason": "too many attempts",
    "acessRights":   {"Manage Location": [
      {
        "key": "AddLocation",
        "label": "Add Location",
        "value": true
      },
      {
        "key": "EditLocation",
        "label": "Edit Location",
        "value": true
      },
      {
        "key": "ViewLocation",
        "label": "View Location",
        "value": true
      },
      {
        "key": "DeleteLocation",
        "label": "Delete Location",
        "value": false
      }
    ],
    "Manage Organization": [
    {
      "key": "AddOrganization",
      "label": "Add Organization",
      "value": true
    },
    {
      "key": "EditOrganization",
      "label": "Edit Organization",
      "value": true
    },
    {
      "key": "ViewOrganization",
      "label": "View Organization",
      "value": true
    },
    {
      "key": "DeleteOrganization",
      "label": "Delete Organization",
      "value": true
    }
  ],
  "Manage Users": [
 
    {
      "key": "ViewUser",
      "label": "View User",
      "value": true
    },
    {
        "key": "EditUser",
        "label": "Edit User",
        "value": true
      },
    {
      "key": "ImpersonateUser",
      "label": "Impersonate User for Support",
      "value": true
    },
    {
      "key": "BanUser",
      "label": "Ban User",
      "value": true
    },
   
    
    {
      "key": "ResetPassword",
      "label": "Reset User Password",
      "value": true
    },
    {
      "key": "ViewAccessRights",
      "label": "View Access Rights of User",
      "value": true
    }
  ]}
  },
  {
    "id": 5,
    "name": "Liu Wei",
    "firstName": "Wei",
    "lastName": "Liu",
    "birthDate": "1995-06-10",
    "gender": "Male",
    "language": "Chinese",
    "languages": ["Chinese", "English"],
    "image": "dashboard-8/user3.png",
    "email": "liu.wei@example.com",
    "phonenumber": "+86-10-5555-1234",
    "organizationname": "Beijing Tech Co.",
    "logo": "dashboard-8/eduspark.png",
    "status": "Active",
    "role": "manager",
    "countryCode": "+86",
    "mobileNumber": "10-5555-1234",
    "country": "China",
    "date": "2024-05-15 08:00:00",
    "reason": "inactive account",
    "acessRights":   {"Manage Location": [
      {
        "key": "AddLocation",
        "label": "Add Location",
        "value": true
      },
      {
        "key": "EditLocation",
        "label": "Edit Location",
        "value": true
      },
      {
        "key": "ViewLocation",
        "label": "View Location",
        "value": true
      },
      {
        "key": "DeleteLocation",
        "label": "Delete Location",
        "value": false
      }
    ],
   
  "Manage Users": [
 
    {
      "key": "ViewUser",
      "label": "View User",
      "value": true
    },
    {
        "key": "EditUser",
        "label": "Edit User",
        "value": true
      },
    {
      "key": "ImpersonateUser",
      "label": "Impersonate User for Support",
      "value": true
    },
    {
      "key": "BanUser",
      "label": "Ban User",
      "value": true
    },
   
    
    {
      "key": "ResetPassword",
      "label": "Reset User Password",
      "value": true
    },
    {
      "key": "ViewAccessRights",
      "label": "View Access Rights of User",
      "value": true
    }
  ]}
  },
  {
    "id": 6,
    "name": "Emma Thompson",
    "firstName": "Emma",
    "lastName": "Thompson",
    "birthDate": "1997-11-15",
    "logo": "dashboard-8/eduspark.png",
    "gender": "Female",
    "language": "English",
    "languages": ["English", "French"],
    "image": "dashboard-8/user2.png",
    "email": "emma.thompson@eg.com",
    "phonenumber": "+44-20-7946-1234",
    "organizationname": "Thompson Analytics",
    "status": "Inactive",
    "role": "employee",
    "countryCode": "+44",
    "mobileNumber": "20-7946-1234",
    "country": "United Kingdom",
    "date": "2024-05-10 07:00:00",
    "reason": "expired password",
    "acessRights":   {"Manage Location": [
      {
        "key": "AddLocation",
        "label": "Add Location",
        "value": true
      },
      {
        "key": "EditLocation",
        "label": "Edit Location",
        "value": true
      },
      {
        "key": "ViewLocation",
        "label": "View Location",
        "value": true
      },
      {
        "key": "DeleteLocation",
        "label": "Delete Location",
        "value": false
      }
    ],

  "Manage Users": [
 
    {
      "key": "ViewUser",
      "label": "View User",
      "value": true
    },
    {
        "key": "EditUser",
        "label": "Edit User",
        "value": true
      },
    {
      "key": "ImpersonateUser",
      "label": "Impersonate User for Support",
      "value": true
    },
    {
      "key": "BanUser",
      "label": "Ban User",
      "value": true
    },
   
    
    {
      "key": "ResetPassword",
      "label": "Reset User Password",
      "value": true
    },
    {
      "key": "ViewAccessRights",
      "label": "View Access Rights of User",
      "value": true
    }
  ]}
  },
  {
    "id": 7,
    "name": "Akira Yamamoto",
    "firstName": "Akira",
    "lastName": "Yamamoto",
    "birthDate": "1994-03-22",
    "gender": "Male",
    "language": "Japanese",
    "languages": ["Japanese", "English"],
    "image": "dashboard-8/user.png",
    "email": "akira.yamamoto@eg.com",
    "phonenumber": "+81-3-5555-7890",
    "organizationname": "Yamato Robotics",
    "logo": "dashboard-8/eduspark.png",
    "status": "Active",
    "role": "admin",
    "countryCode": "+81",
    "reason": "Network issue",
    "mobileNumber": "3-5555-7890",
    "country": "Japan",
    "date": "2024-05-05 06:00:00",
    "acessRights":   {"Manage Location": [
      {
        "key": "AddLocation",
        "label": "Add Location",
        "value": true
      },
      {
        "key": "EditLocation",
        "label": "Edit Location",
        "value": true
      },
      {
        "key": "ViewLocation",
        "label": "View Location",
        "value": true
      },
      {
        "key": "DeleteLocation",
        "label": "Delete Location",
        "value": false
      }
    ],}
  },
  {
    "id": 8,
    "name": "Fatima Al-Farsi",
    "firstName": "Fatima",
    "lastName": "Al-Farsi",
    "birthDate": "1998-12-05",
    "gender": "Female",
    "language": "Arabic",
    "languages": ["Arabic", "English"],
    "image": "dashboard-8/user1.png",
    "email": "fatima.alfarsi@eg.com",
    "phonenumber": "+971-2-555-1234",
    "logo": "dashboard-8/eduspark.png",
    "organizationname": "MiddleEast Tech",
    "reason": "Time Out",
    "status": "Active",
    "role": "employee",
    "countryCode": "+971",
    "mobileNumber": "2-555-1234",
    "country": "UAE",
    "date": "2024-05-01 05:00:00",
    "acessRights":   {"Manage Location": [
      {
        "key": "AddLocation",
        "label": "Add Location",
        "value": true
      },
      {
        "key": "EditLocation",
        "label": "Edit Location",
        "value": true
      },
      {
        "key": "ViewLocation",
        "label": "View Location",
        "value": true
      },
      {
        "key": "DeleteLocation",
        "label": "Delete Location",
        "value": false
      }
    ],
  
  "Manage Users": [
 
    {
      "key": "ViewUser",
      "label": "View User",
      "value": true
    },
    {
        "key": "EditUser",
        "label": "Edit User",
        "value": true
      },
    {
      "key": "ImpersonateUser",
      "label": "Impersonate User for Support",
      "value": true
    },
    {
      "key": "BanUser",
      "label": "Ban User",
      "value": true
    },
   
    
    {
      "key": "ResetPassword",
      "label": "Reset User Password",
      "value": true
    },
    {
      "key": "ViewAccessRights",
      "label": "View Access Rights of User",
      "value": true
    }
  ]}
  },
  {
    "id": 9,
    "name": "Carlos Rivera",
    "firstName": "Carlos",
    "lastName": "Rivera",
    "birthDate": "1992-07-07",
    "gender": "Male",
    "language": "Spanish",
    "logo": "dashboard-8/linnk_logo.png",
    "languages": ["Spanish", "English"],
    "image": "dashboard-8/user.png",
    "email": "carlos.rivera@exa.com",
    "phonenumber": "+34-91-555-6789",
    "organizationname": "Rivera Logistics",
    "status": "Inactive",
    "reason": "inactive account",
    "role": "employee",
    "countryCode": "+34",
    "mobileNumber": "91-555-6789",
    "country": "Spain",
    "date": "2024-04-28 04:00:00",
    "acessRights":   {"Manage Location": [
      {
        "key": "AddLocation",
        "label": "Add Location",
        "value": true
      },
      {
        "key": "EditLocation",
        "label": "Edit Location",
        "value": true
      },
      {
        "key": "ViewLocation",
        "label": "View Location",
        "value": true
      },
      {
        "key": "DeleteLocation",
        "label": "Delete Location",
        "value": false
      }
    ],
 
  "Manage Users": [
 
    {
      "key": "ViewUser",
      "label": "View User",
      "value": true
    },
    {
        "key": "EditUser",
        "label": "Edit User",
        "value": true
      },
    {
      "key": "ImpersonateUser",
      "label": "Impersonate User for Support",
      "value": true
    },
    {
      "key": "BanUser",
      "label": "Ban User",
      "value": true
    },
   
    
    {
      "key": "ResetPassword",
      "label": "Reset User Password",
      "value": true
    },
    {
      "key": "ViewAccessRights",
      "label": "View Access Rights of User",
      "value": true
    }
  ]}
  },
  {
    "id": 10,
    "name": "Sofia Petrova",
    "firstName": "Sofia",
    "lastName": "Petrova",
    "birthDate": "1990-08-25",
    "gender": "Female",
    "reason": "Wrong Password",
    "logo": "dashboard-8/linnk_logo.png",
    "language": "Russian",
    "languages": ["Russian", "English"],
    "image": "dashboard-8/user1.png",
    "email": "sofia.petrova@exa.com",
    "phonenumber": "+7-495-555-2468",
    "organizationname": "Petrova Software",
    "status": "Active",
    "role": "manager",
    "countryCode": "+7",
    "mobileNumber": "495-555-2468",
    "country": "Russia",
    "date": "2024-04-25 03:00:00",
    "acessRights":   {"Manage Location": [
      {
        "key": "AddLocation",
        "label": "Add Location",
        "value": true
      },
      {
        "key": "EditLocation",
        "label": "Edit Location",
        "value": true
      },
      {
        "key": "ViewLocation",
        "label": "View Location",
        "value": true
      },
      {
        "key": "DeleteLocation",
        "label": "Delete Location",
        "value": false
      }
    ],
    "Manage Organization": [
    {
      "key": "AddOrganization",
      "label": "Add Organization",
      "value": true
    },
    {
      "key": "EditOrganization",
      "label": "Edit Organization",
      "value": true
    },
    {
      "key": "ViewOrganization",
      "label": "View Organization",
      "value": true
    },
    {
      "key": "DeleteOrganization",
      "label": "Delete Organization",
      "value": true
    }
  ],

  }
  }
];
const UserListTableAction: React.FC<{ row: UserListTableDataColumnType }> = ({
  row,
}) => {

  const { t } = useTranslation();


  return (
    <UncontrolledDropdown>
      <DropdownToggle tag="span" className="cursor-pointer">
        <MoreVertical size={18} />
      </DropdownToggle>
      <DropdownMenu>
        <Link to={`${process.env.PUBLIC_URL}/organizationAdmin/view/${row.id}`}>
          <DropdownItem>{t("View")}</DropdownItem>
        </Link>

        <Link to={`${process.env.PUBLIC_URL}/organizationAdmin/edit/${row.id}`}>
          <DropdownItem>{t("Edit")}</DropdownItem>
        </Link>

        <DropdownItem>{t("Block")}</DropdownItem>
        <DropdownItem>{t("Unblock")}</DropdownItem>
        <DropdownItem>{t("Delete")}</DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

const UserListTableName: React.FC<UserListTableNameProps> = ({
  image,
  name,
}) => {
  return (
    <div className="product-names my-2">
      <div className="media-left">
        <Image
          className="media-object rounded-circle img-40"
          src={dynamicImage(image)}
          alt="organization"
        />
      </div>
      <P>{name}</P>
    </div>
  );
};

const ProductListTableStatus: React.FC<{ status?: string }> = ({ status }) => {
  return (
    <Badges
      color="transparent"
      className={`badge-light-${
        status === "Inactive" ? "secondary" : "primary"
      }`}
    >
      {status}
    </Badges>
  );
};

export const UserListTableDataColumn = (
  t: TFunction
): TableColumn<UserListTableDataColumnType>[] => [
  {
    name: t("Name"),
    cell: (row) => <UserListTableName image={row.image} name={row.name} />,
    sortable: true,
  },
  {
    name: t("email"),
    selector: (row) => `${row.email}`,
    sortable: true,
  },
  {
    name: t("phonenumber"),
    selector: (row) => `${row.phonenumber}`,
    sortable: true,
  },
  {
    name: t("OrganizationName"),
    selector: (row) => `${row.organizationname}`,
    sortable: true,
  },

  {
    name: t("Status"),
    cell: (row) => <ProductListTableStatus status={row.status} />,
  },

  {
    name: t("Actions"),
    cell: (row) => <UserListTableAction row={row} />,
    center: true,
    minWidth: "50px",
  },
];
